import { useEffect, useRef } from "react";
import { ImageOverlay, useMap } from "react-leaflet";

const ImageOverlayDraw = ({ imageUrl, bounds }) => {
  const map = useMap();
  const imageOverlayRef = useRef(null);

  useEffect(() => {
    if (imageOverlayRef.current) {
      map.removeLayer(imageOverlayRef.current);
    }
    if (imageUrl && bounds) {
      imageOverlayRef.current = new ImageOverlay(imageUrl, bounds).addTo(map);
    }
    return () => {
      if (imageOverlayRef.current) {
        map.removeLayer(imageOverlayRef.current);
      }
    };
  }, [imageUrl, bounds, map]);

  return null;
};

export default ImageOverlayDraw;
